// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3ToT2","title":"ClientReferral_title__3f_3t","itemText":"ClientReferral_itemText__2NZeR"};